import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

export class InsuredSinceStep extends React.Component<IStepProps, IStepState> {

    state: IStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }
    }
        
    handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        let valueElement = event.target as HTMLAnchorElement;
        let value = valueElement.dataset["value"];

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.currentInsurance.insuredSince = value;
        
        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.GENDER);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    getSelectedClass(optionValue: string): string {
        if (optionValue === this.props.model.currentInsurance.insuredSince) {
            return "selected";
        }
        return "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }
        
        const h4Classes: string = "text-center";

        return <React.Fragment>
            <LogStep lastStep="InsuranceCarrier" nextStep="Gender" stepNumber={QuoteFormEventType.CurrentInsuranceStep} sectionName="InsuredSince" wizardName="AutoWizard" logStep={true}/>
            <div id="InsuredSinceStep" className={sectionClasses} style={sectionStyle}>
                   <h3>How long have you continuously had insurance?</h3>
                    <h4 className={h4Classes}>(Including with different carriers)</h4>
                   <div id="InsuredSince">
                       <div className="touch-list oneColumn">
                           <div className="touch-list-option"><a className={this.getSelectedClass("LessThanSixMonths")} onClick={this.handleOnClick} id="insuredSince_lessThanSixMonths" data-value="LessThanSixMonths">Less than 6 months</a></div>
                        <div className="touch-list-option"><a className={this.getSelectedClass("SixMonthsToOneYear")} onClick={this.handleOnClick} id="insuredSince_sixMonths" data-value="SixMonthsToOneYear">6 months - 1 year </a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("OneYear")} onClick={this.handleOnClick} id="insuredSince_oneYear" data-value="OneYear">1 year</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("TwoYears")} onClick={this.handleOnClick} id="insuredSince_twoYears" data-value="TwoYears">2 years</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("ThreeYears")} onClick={this.handleOnClick} id="insuredSince_threeYears" data-value="ThreeYears">3 years or more</a></div>
                       </div>
                   </div>
            </div>
        </React.Fragment>;
    }
}